import { render, staticRenderFns } from "./shopPopupNotice.vue?vue&type=template&id=03ca8ec1&scoped=true"
import script from "./shopPopupNotice.vue?vue&type=script&lang=ts"
export * from "./shopPopupNotice.vue?vue&type=script&lang=ts"
import style0 from "./shopPopupNotice.vue?vue&type=style&index=0&id=03ca8ec1&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca8ec1",
  null
  
)

export default component.exports